if (!customElements.get('yakjak-variant-gallery')) {
  customElements.define('yakjak-variant-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.syncDescription();
      this.descriptionObserver?.disconnect();
      this.descriptionObserver = new MutationObserver(() => this.syncDescription());
      const productSection = this.closest('product-component');
      if (productSection) this.descriptionObserver.observe(productSection, {childList:true,subtree:true});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-show-frame]');
        if (!button) return;
        const group = button.closest('.yjvg-group');
        this.showFrame(group, button.dataset.showFrame);
      }, {signal});
      document.addEventListener('change', event => {
        const picker = event.target.closest('variant-picker');
        if (!picker || picker.dataset.productId !== this.dataset.productId) return;
        const values = [...picker.querySelectorAll('fieldset')].map(field => {
          const input = field.querySelector('input:checked,select');
          return input?.value;
        });
        const group = [...this.querySelectorAll('.yjvg-group')].find(group =>
          JSON.stringify(JSON.parse(group.dataset.options)) === JSON.stringify(values));
        if (!group) return;
        this.querySelectorAll('.yjvg-group').forEach(item => {
          item.hidden = item !== group;
          if (item !== group) item.querySelectorAll('yakjak-spin').forEach(spin => spin.pause?.());
        });
        this.showFrame(group, '0');
        this.syncDescription();
        document.querySelectorAll('[data-yakjak-price-product]').forEach(price => {
          if (price.dataset.yakjakPriceProduct === this.dataset.productId) price.textContent = group.dataset.money;
        });
      }, {signal});
    }
    showFrame(group, index) {
      group.querySelectorAll('.yjvg-stage > [data-frame]').forEach(frame => frame.hidden = frame.dataset.frame !== index);
      group.querySelector('.yjvg-stage').classList.toggle('yjvg-stage--spin', index === 'spin');
      if (index !== 'spin') group.querySelectorAll('yakjak-spin').forEach(spin => spin.pause?.());
      group.querySelectorAll('[data-show-frame]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showFrame === index)));
    }
    syncDescription() {
      const group = this.querySelector('.yjvg-group:not([hidden])');
      if (!group) return;
      const [size, finish] = JSON.parse(group.dataset.options);
      const scope = this.closest('product-component');
      if (!scope) return;
      const copy = {
        '.yj-selected-model': `YakJak ${size} Adjustable Dual-Ball Hitch · ${finish}`,
        '.yj-selected-fit': `${size} adjustable drop/rise. ${finish} finish. Fits a standard 2-inch receiver.`,
        '.yj-capacity-label': `Towing Capacity: ${size} Model`
      };
      for (const [selector, text] of Object.entries(copy)) {
        scope.querySelectorAll(selector).forEach(element => {
          if (element.textContent !== text) element.textContent = text;
        });
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.descriptionObserver?.disconnect(); }
  });
}
